const ProspectManufacturerOptionConstant = {
  PRODUCT_REPAIR_WITH_GUARANTEE: 'PRODUCT_REPAIR_WITH_GUARANTEE',
  PRODUCT_REPAIR_WITHOUT_GUARANTEE: 'PRODUCT_REPAIR_WITHOUT_GUARANTEE',
  CREDIT_OR_REFUND: 'CREDIT_OR_REFUND',
  PRODUCT_REPLACEMENT: 'PRODUCT_REPLACEMENT',
  REJECT_PROSPECT: 'REJECT_PROSPECT',
  OTHER: 'OTHER'
}

export default ProspectManufacturerOptionConstant;
